<div
  class="overflow-hidden rounded-2xl border border-gray-200 bg-white px-5 pt-5 dark:border-gray-800 dark:bg-white/[0.03] sm:px-6 sm:pt-6">

  <!-- HEADER -->
  <div class="flex items-center justify-between">
    <div>
      <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">Ingresos del mes</h3>
      <p class="text-xs text-gray-400 dark:text-gray-500 mt-0.5">Ingresos diarios (ventas − NC + ND aceptadas)</p>
    </div>

    <!-- NAVEGACIÓN MES -->
    <div class="flex items-center gap-2">
      <button type="button" (click)="prevMonth()" [disabled]="loading"
        class="flex h-8 w-8 items-center justify-center rounded-lg border border-gray-200 text-gray-500 transition-colors hover:bg-gray-50 hover:text-gray-700 disabled:opacity-40 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
        </svg>
      </button>

      <span class="min-w-30 text-center text-sm font-medium text-gray-700 dark:text-gray-300">
        {{ monthLabel }}
      </span>

      <button type="button" (click)="nextMonth()" [disabled]="!canGoNext || loading"
        [ngClass]="!canGoNext ? 'opacity-30 cursor-not-allowed' : 'hover:bg-gray-50 hover:text-gray-700 dark:hover:bg-gray-800 dark:hover:text-gray-200'"
        class="flex h-8 w-8 items-center justify-center rounded-lg border border-gray-200 text-gray-500 transition-colors disabled:opacity-40 dark:border-gray-700 dark:text-gray-400">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  </div>

  <!-- CHART / SKELETON -->
  <div class="max-w-full overflow-x-auto custom-scrollbar mt-2">
    <div class="-ml-5 min-w-[650px] xl:min-w-full pl-2">

      @if (loading) {
      <div class="flex items-end gap-1 h-45 px-4">
        @for (h of [40,70,55,90,30,80,65,45,75,60,85,50,35,95,70,55,40,80,65,50,75,30,90,60,45,85,55,70]; track $index) {
        <div class="flex-1 animate-pulse rounded-t-sm bg-gray-200 dark:bg-gray-700"
          [style.height.%]="h"></div>
        }
      </div>
      } @else {
      <apx-chart [series]="series" [chart]="chart" [xaxis]="xaxis" [plotOptions]="plotOptions"
        [dataLabels]="dataLabels" [stroke]="stroke" [legend]="legend" [yaxis]="yaxis" [grid]="grid"
        [fill]="fill" [tooltip]="tooltip" [colors]="colors">
      </apx-chart>
      }

    </div>
  </div>

</div>